import { proxy } from "valtio"
import { devtools } from "valtio/utils"
import { ScoringByItem } from "../models/scoringByItem"
import {
  PracticeTestAssessmentKeyItem,
  ResponsesByPracticeTest
} from "../types"

export type ReviewStateType = {
  testScoring: ScoringByItem
  groupMode: boolean
  contentPreviewMode: boolean
  groupTestScoring: ResponsesByPracticeTest
  groupCorrectAnswers: PracticeTestAssessmentKeyItem[]
}

const initialState: ReviewStateType = {
  testScoring: null,
  groupMode: false,
  contentPreviewMode: false,
  groupTestScoring: null,
  groupCorrectAnswers: []
}

export const ScoringState = proxy<ReviewStateType>(initialState)

export const setScoring = (data: ScoringByItem) => {
  ScoringState.testScoring = data
}

export const setGroupMode = (groupMode: boolean) => {
  ScoringState.groupMode = groupMode
}

export const setContentPreviewMode = (contentPreviewMode: boolean) => {
  ScoringState.contentPreviewMode = contentPreviewMode
}

export const setGroupTestScoring = (
  groupTestScoring: ResponsesByPracticeTest,
  groupCorrectAnswers: PracticeTestAssessmentKeyItem[]
) => {
  ScoringState.groupTestScoring = groupTestScoring
  ScoringState.groupCorrectAnswers = groupCorrectAnswers
}

export const resetReviewState = () => {
  ScoringState.testScoring = initialState.testScoring
  ScoringState.groupMode = initialState.groupMode
  ScoringState.contentPreviewMode = initialState.contentPreviewMode
  ScoringState.groupTestScoring = initialState.groupTestScoring
  ScoringState.groupCorrectAnswers = initialState.groupCorrectAnswers
}

process.env.NODE_ENV === "development" &&
  devtools(ScoringState, { enabled: true, name: "ScoringState" })
